<script>
import Simplebar from "simplebar-vue"; // Importing the Simplebar component for custom scrollbars
import { BDropdown } from "bootstrap-vue"; // Importing the BDropdown component from BootstrapVue
import { IconBars, IconBell, IconRedDot } from "@/components/icons/index"; // Importing custom icon components
import { BSpinner } from 'bootstrap-vue'
import { notifications } from "@/services/index";
export default {
	name: "AppNotification", // Component name
	components: {
		Simplebar, // Custom scrollbar component
		BDropdown, // BootstrapVue dropdown component
		IconBars, // Custom icon component
		IconBell, // Custom icon component
		IconRedDot, // Custom icon component
		BSpinner
	},
	data() {
		return {
			showUnreadCount: true, // Flag to show/hide the unread count badge
			notificationsData: [], // Array to store notifications
			notificationInterval: null, // Property to hold the interval ID for periodic fetching of notifications
			isCurrentShown: false,
			detailPages: {
				'PROMO': 'Promo',
				'USER MANAGEMENT': 'CustomerProfile',
				'PRODUCT REGISTRATION': 'CmpView',
				'PRODUCT REPAIR': 'ProductRepair',
				'WARRANTY & AFTERSALES': 'WarrantyView'
			},
			hasScrollEndEvent: false,
			loadingData: false,
			unReadCount: 0,
			last_page: 1,
			page: 1,
		};
	},
	watch: {
		notificationsData(ov) {
			if (this.notificationsData.length > 0) {
				this.addScrollListener();
				this.hasScrollEndEvent = true
			} else {
				this.removeScroll();
				this.hasScrollEndEvent = false
			}
		},
        $route(to, from) {
			if (from && from.name === 'View All Notifications') {
				setTimeout(() => {
					this.requestGetNotification()
				}, 800);
			}
        }
	},
	methods: {
		async requestGetNotification(isInit = true, isEmpty = false) {
			// Set the flag to show the unread count badge
			if (!this.isCurrentShown) {
				this.showUnreadCount = true;
				// console.log("requestGetNotification but hide");
			} else {
				// console.log("requestGetNotification but show");
			}

			try {

				try {
					let params = {
						page: this.page
					}
					const response = await notifications.getBellNotifications(params);
					this.unReadCount = response.data.unread_count;
					this.last_page = response.data.notifications.last_page;

					// If isInit == true, dont update the this.notificationsData
					if (!isInit) {
						// Method to simulate an API call to fetch new notifications
						const items = response.data.notifications.data; // actual data

						if (isEmpty) {
							this.notificationsData = [];
						}

						if (items.length > 0) {
							let newArr = items.map((item, index) => {
								if (item.function === 'PRODUCT REPAIR') {
									item.notification = `${item.customer_name} ${item.action}`
								} else {
									item.notification = `${item.customer_name} ${item.action} ${item.related_id ? '#' + item.related_id : ''}`
								}
								item.is_opened = item.is_read && item.is_read === 1 ? true : false;
								return item
							});

							this.notificationsData = [...this.notificationsData, ...newArr]; // Update the notification array with new notifications
						}
					}

				} catch (error) {
					console.warn(error);
				}
			} catch (error) {
				console.error(error)
			}
		},
		async updateIsRead(item) {
			// Method to mark a notification as read and navigate to the relevant view
			this.hideNotif();
			this.$refs.notificationDropdown.hide();

			if (
				this.$route.name === this.detailPages[item.function] &&
				this.$route.params.id == item.related_id
			) {
				console.log("Same ID");
				return; // If already on the relevant view, do nothing
			}

			this.goDetailPage(this.detailPages[item.function], item.related_id)

			// TODO: look for this code, and set current tab title to disable the warranty or ask BE to provide the field
			// CmpView.vue
			// if (localStorage.getItem('current-tab-title') && localStorage.getItem('current-tab-title') == 'Approved') {
			// 	this.disableEditWarranty = true;
			// }
		},
		openNotif() {
			// Method to handle the event when the notification dropdown is shown
			this.showUnreadCount = false;
			this.isCurrentShown = true;
			this.page = 1;
			this.requestGetNotification(false, true);
		},
		hideNotif() {
			// Method to handle the event when the notification dropdown is hidden
			this.showUnreadCount = true;
			this.isCurrentShown = false;
		},
		goDetailPage(name, id) {
			this.$router.push({
				name: name,
				params: { id: id }
			}).catch(()=>{});
			setTimeout(() => {
				this.requestGetNotification()
			}, 800);
		},
		addScrollListener() {
			this.$nextTick(() => {
				if (this.$refs.simplebarnotif) {
					const simplebarContent = this.$refs.simplebarnotif.$el.querySelector('.simplebar-content-wrapper');
					if (simplebarContent) {
						simplebarContent.addEventListener('scroll', this.handleScroll);
					}
				}
			});
		},
		async handleScroll(event) {
			const element = event.target;
			if (element.scrollHeight - element.scrollTop <= element.clientHeight + 1) {
				// console.log('Scrolled to the end');
				// Perform the desired action when scrolled to the end

				if (this.page === this.last_page || this.page >= this.last_page) {
					this.page = this.last_page;
					console.log('no more data')
					return
				}
				this.page = this.page + 1;
				this.loadingData = true;
				await this.requestGetNotification(false)
				this.loadingData = false;
			}
		},
		removeScroll() {
			if (this.$refs.simplebarnotif) {
				const simplebarContent = this.$refs.simplebarnotif.$el.querySelector('.simplebar-content-wrapper');
				if (simplebarContent) {
					simplebarContent.removeEventListener('scroll', this.handleScroll);
				}
			}
		},
	},
	mounted() {
		// Lifecycle hook called when the component is mounted
		if (this.notificationInterval) {
			clearInterval(this.notificationInterval); // Clear any existing interval
		}

		this.requestGetNotification(false); // Fetch notifications initially
		this.notificationInterval = setInterval(
			this.requestGetNotification,
			300000
		); // Set interval to fetch notifications every 5 seconds

		this.$root.$on('bv::dropdown::hide', bvEvent => {
			this.hideNotif();
		})
	},
	beforeDestroy() {
		this.removeScroll();

		// Lifecycle hook called before the component is destroyed
		if (this.notificationInterval) {
			clearInterval(this.notificationInterval); // Clear the interval when the component is destroyed
		}
	},
};
</script>

<template>
    <b-dropdown
		ref="notificationDropdown"
        variant="white"
        class="dropdown d-inline-block"
        toggle-class="header-item noti-icon"
        right
        menu-class="dropdown-menu-xl p-0 dropdown-menu-end"
        @shown="openNotif"
    >
        <template v-slot:button-content>
            <IconBell size="22px" />
            <span
                v-if="unReadCount > 0 && showUnreadCount"
                class="badge bg-danger rounded-pill"
                >{{ unReadCount }}</span
            >
        </template>

        <div class="p-3">
            <div class="row align-items-center">
                <div class="col">
                    <h5 class="m-0 font-size-16">Notifications</h5>
                </div>
                <div class="col-auto">
                    <a href="/view-all-notifications" class="small">View All</a>
                </div>
            </div>
        </div>

        <Simplebar
			ref="simplebarnotif"
            v-if="notificationsData.length > 0"
            style="max-height: 230px;position: relative;"
            data-simplebar
			@scroll="handleScroll"
        >
            <a
                v-for="(item, key) in notificationsData"
                :key="key"
                @click.prevent="updateIsRead(item, key)"
                href
                class="text-reset notification-item"
                :class="[item.is_read === 0 ? 'unread-bg' : null]"
            >
                <div class="media">
                    <div class="red-dot">
                        <IconRedDot
                            v-if="item.is_read === 0"
                            :size="'9px'"
                            :colorFill="'#D6001B'"
                        ></IconRedDot>
                    </div>
                    <img
                        :src="'/assets/images/placeholder-user.jpg'"
                        class="me-3 rounded-circle avatar-xs"
                        alt="user-avatar"
                    />
                    <div class="media-body">
                        <div class="font-size-12">
                            <!-- <p
                                v-if="item.type === 'registration'"
                                class="mb-1 desc font-size-13"
                            >
                                {{ item.customer + " " }} followed up on his
                                product registration {{ "#" + item.product_id }}
                            </p>
                            <p
                                v-if="item.type === 'request'"
                                class="mb-1 desc font-size-13"
                            >
                                {{ item.customer + " " }} requesting a product
                                repair
                            </p> -->
							<p class="mb-1 desc font-size-13">
								{{ item.notification }}
							</p>
                            <p class="mb-0 time">
								{{ item.date_created }}
                            </p>
                        </div>
                    </div>
                </div>
            </a>
			<div v-if="loadingData" class="spin-wrap">
				<b-spinner
				variant="primary"
				style="width: 1.5rem;height: 1.5rem;"
				></b-spinner>
			</div>
        </Simplebar>

        <div v-else class="text-center empty-list">
            <span>No notifications</span>
        </div>
    </b-dropdown>
</template>

<style>
.spin-wrap {
	display: flex;
	justify-content: center;
	align-items: center;
	padding-top: 10px;
	padding-bottom: 10px;
}
</style>
<style lang="scss" scoped>
.notification-item {
	display: flex;
}

.notification-item>div {
	flex: 1;
}

// .notification-item:not(:last-child) .media {
//     border-bottom: 1px solid rgba(73, 80, 87, 0.3);
// }

.media {
	padding: 12px 20px 12px 12px !important;
	position: relative;
	min-height: 85px;
}

.notification-item:not(:last-child) .media::after {
	content: "";
	position: absolute;
	bottom: 0;
	right: 14px;
	left: 14px;
	height: 1px;
	background-color: rgba(73, 80, 87, 0.1);
	// width: calc(100% - 24px);
	// border-bottom: 1px solid rgba(73, 80, 87, 0.3);
}

.red-dot {
	margin-right: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 18px;
	padding-top: 10px;
}

.desc {
	color: #495057;
	// font-size: 14px;
	font-weight: 600;
}

.time {
	color: #74788d;
	// font-size: 12px;
}

.empty-list {
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 230px;
}

.empty-list>span {
	color: #74788d;
	font-size: 14px;
}

.notification-item.unread-bg {
	background-color: #fbeeef;
}

.notification-item.unread-bg .media:hover {
	background-color: #fbeeef !important;
	background: #fbeeef !important;
}
</style>
